<script lang="ts">
	import { createEventDispatcher } from 'svelte';
  import SimpleCaption from './SimpleCaption.svelte';

  export let value: string;
	
  export let label = '';
  export let caption = '';
  export let maxLength = 1000;
  export let placeholder = 'Enter here';
  export let danger: boolean = false;
  export let required: boolean = false;

  export let dangerMessage: string = '';

  const dispatch = createEventDispatcher();

  $: {
    value, label;
    dispatch('change', { value, label });
  }

  function handleSubmit() {
    dispatch('submit', value);
  }
</script>

<div class="flex flex-col items-start gap-2 w-full h-full">
	<label class="text-garden-grey-600 font-medium text-sm flex flex-row justify-between w-full" for="">
		<span>
			{#if label}{label}{:else}&nbsp;{/if}
			{#if required}<span class="text-red-500">*</span>{/if}
		</span>
		<span class="text-garden-grey-400 text-xs" class:danger-wordcount={danger}>
			{#if maxLength}
				{value?.length || 0}/{maxLength}
			{/if}
		</span>
	</label>
	<div class="relative w-full">
		<textarea
			class="input-style min-h-[120px] w-full border border-garden-grey-300 rounded-14 p-4 placeholder:text-garden-grey-400 text-garden-grey-600text-garden-grey-600 outline-none ease-out duration-100"
			class:input-danger={danger}
			bind:value
			on:blur={() => {
				dispatch('blur', { value, label });
			}}
			rows="5"
			on:keydown
			on:keydown={(event) => {
				if (event.key === 'Enter') {
					handleSubmit();
				}
			}}
			{required}
			{placeholder}
			maxlength={maxLength}
		/>
		<div class="absolute right-1 bottom-3">
			<svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M8 5L5 8M8 1L1 8" stroke="#212529" stroke-opacity="0.16" stroke-linecap="square" />
			</svg>
		</div>
	</div>
	<SimpleCaption {danger} {dangerMessage} {caption} />
</div>

<style type="postcss">
  ::-webkit-resizer {
    display: none;
  }

  .input-style:focus {
    box-shadow:
      1px 1px 2px rgba(0, 0, 0, 0.07),
      0px 0px 0px 4px #ecefff;
  }
  .input-danger {
    @apply border-accent-red-40;
  }
  .input-danger:focus {
    box-shadow:
      1px 1px 2px rgba(0, 0, 0, 0.07),
      0px 0px 0px 4px #ffecec;
  }
  .danger-wordcount {
    @apply text-accent-red-40;
  }
</style>
